module.exports = __webpack_public_path__ + "static/media/squared.53b30534.jpg";